import { useQuery } from '@tanstack/react-query';

import { AnalyticsRange, analyticsApi } from '@/services';

const STALE_TIME = 5 * 60 * 1000;

export const analyticsKeys = {
  summary: (r: AnalyticsRange) => ['analytics', 'summary', r] as const,
  funnel: (r: AnalyticsRange) => ['analytics', 'funnel', r] as const,
  forms: (r: AnalyticsRange) => ['analytics', 'forms', r] as const,
  downloads: (r: AnalyticsRange) => ['analytics', 'downloads', r] as const,
};

export function useAnalyticsSummaryQuery(range: AnalyticsRange) {
  return useQuery({
    queryKey: analyticsKeys.summary(range),
    queryFn: () => analyticsApi.getSummary(range),
    staleTime: STALE_TIME,
  });
}

export function useAnalyticsFunnelQuery(range: AnalyticsRange) {
  return useQuery({
    queryKey: analyticsKeys.funnel(range),
    queryFn: () => analyticsApi.getFunnel(range),
    staleTime: STALE_TIME,
  });
}

export function useAnalyticsFormsQuery(range: AnalyticsRange) {
  return useQuery({
    queryKey: analyticsKeys.forms(range),
    queryFn: () => analyticsApi.getForms(range),
    staleTime: STALE_TIME,
  });
}

export function useAnalyticsDownloadsQuery(range: AnalyticsRange) {
  return useQuery({
    queryKey: analyticsKeys.downloads(range),
    queryFn: () => analyticsApi.getDownloads(range),
    staleTime: STALE_TIME,
  });
}
